import { Link } from 'components'
import React from 'react'

import SectionContent from '../../components/SectionContent'
import SectionLayout from '../../components/SectionLayout'

const QuerySection = () => {
  return (
    <SectionLayout className="py-8">
      <SectionContent>
        <p className="text-xl">
          Have query?{' '}
          <Link href={''} className="text-primary font-bold hover:underline">
            ping us{' '}
          </Link>
        </p>
      </SectionContent>
    </SectionLayout>
  )
}

export default QuerySection
